import FeaturesSection from '../components/UI/FeaturesSection/FeaturesSection';
import Footer from '../components/UI/Footer/Footer';
import Header from '../components/UI/Header/Header';
import MainSection from '../components/UI/MainSection/MainSection';
import MainTeam from '../components/UI/MainTeam/MainTeam';

const PageСollector = () => {


  return (
    <>
      <Header />
      <MainSection />
      <FeaturesSection />
      <MainTeam />
      <Footer />
    </>
  );
}

export default PageСollector;